module.exports = __webpack_public_path__ + "img/telluride-multi-2022.d41eaa2a.jpg";